import { DEFAULT_FUNNEL_ID, DEFAULT_FUNNELS, TEMPLATES } from "../config.js";

function cloneFunnels(funnels) {
  return funnels.map((f) => ({ id: f.id, title: f.title, stages: f.stages.map((s) => ({ ...s })) }));
}

export const state = {
  // auth
  userEmail: "",
  authToken: "",
  user: null,
  loginError: "",
  loginPending: false,
  connectionStatus: "offline",

  // crm core
  leads: [],
  funnels: cloneFunnels(DEFAULT_FUNNELS),
  activeFunnelId: DEFAULT_FUNNEL_ID,
  templates: TEMPLATES,
  templateId: "primeiro",
  shortcuts: [],

  // ui
  view: "loading", // loading | login | onboarding | crm
  panel: "kanban", // kanban | chats | admin | shortcuts
  query: "",
  tagFilter: "",
  selectedLeadId: "",
  newLeadAlertIds: [],
  bulkSelectedLeadIds: [],
  theme: "light",

  // whatsapp api integration
  whatsappSession: null, // {sessionId, status, jid, phone, pushName, lastQrDataUrl}
  accounts: [],
  accountFilter: [],
  chats: [], // [{chatJid, pushName, lastText, lastTsMs, unreadCount, leadId, ...}]
  activeChatJid: "",
  chatMessages: {}, // {chatJid: [msg, ...]}
  chatLoading: {}, // {chatJid: bool}
  composer: { text: "", chatJid: "" },
  qrPolling: false,
  chatListSearch: "",
  chatListFilter: "all", // all | unread | groups | tag:<id>
  chatTags: [], // [{id, name, color, position}] — owned by this user
  chatContextMenu: null, // { chatJid, x, y } or null
};

const listeners = new Set();
let externalPatch = null;

export function onChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function emitChange() {
  for (const fn of listeners) {
    try { fn(state); } catch (err) { console.error(err); }
  }
  if (externalPatch) externalPatch({ ...state });
}

export function patch(partial) {
  Object.assign(state, partial);
  emitChange();
}

export function installExternalStoreBridge({ patch: patchFn } = {}) {
  externalPatch = typeof patchFn === "function" ? patchFn : null;
}

export function syncLegacyStateFromReact(nextState) {
  Object.assign(state, nextState || {});
}
